import React from 'react';
import { styles } from './ImageBox.css';
import { ContentfulImage } from '../ContentfulImage/ContentfulImage';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { PossiblyResponsiveValue, useResponsiveValue } from '../hooks/useResponsiveValue';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { Link } from '../PlatformFunctionality';

export type ImageBoxProps = {
  src: string;
  alt: string;
  href?: string;
  size?: PossiblyResponsiveValue<number>;
};

export const ImageBox = ({ src, alt, href, size: sizeProp = { xs: 100, md: 180 } }: ImageBoxProps) => {
  const size = useResponsiveValue(sizeProp);

  const contentfulImage = (
    <ContentfulImage
      src={src}
      alt={alt}
      className={styles.image}
      style={{ width: size, height: size }}
      sizes={`${size}px`}
    />
  );

  return href
    ? React.createElement(Link, { className: styles.container, href: href }, contentfulImage)
    : React.createElement(React.Fragment, null, contentfulImage);
};

export type ImageBoxCarouselProps = { imageBoxes: Array<ImageBoxProps> };

export const ImageBoxCarousel = ({ imageBoxes }: ImageBoxCarouselProps) => {
  const isMobile = !useBreakpoint('md', 'up');

  return (
    <Carousel
      showPagination={false}
      slidesPerView="auto"
      slidesOffsetBefore={10}
      slidesPerGroup={isMobile ? 2 : 3}
      rewind
      slidesOffsetAfter={isMobile ? 0 : 40}
      spaceBetween={10}
      gradientColor={palette.secondary.main}
      hideGradients={isMobile}
      fullBleed={isMobile}
    >
      {imageBoxes.map((imageBoxProps, i) => (
        <ImageBox {...imageBoxProps} key={i} />
      ))}
    </Carousel>
  );
};
